import { makeAutoObservable, action, observable, computed, runInAction } from "mobx";
import { get } from "lodash";
import { RequestState, defaultErrorMessage } from "../constants";
import apiService from "../services/apiService";

export class WaitlistController {
  email = "";
  fullName = "";
  consent = false;
  requestState = RequestState.IDLE;
  errorMessage = "";
  successMessage = "";

  constructor() {
    makeAutoObservable(this, {
      email: observable,
      fullName: observable,
      consent: observable,
      requestState: observable,
      errorMessage: observable,
      successMessage: observable,
      setEmail: action,
      setFullName: action,
      setConsent: action,
      submit: action,
      reset: action,
      isSubmitting: computed,
      isSuccess: computed,
      canSubmit: computed,
    });
  }

  setEmail(value) {
    this.email = value;
  }

  setFullName(value) {
    this.fullName = value;
  }

  setConsent(value) {
    this.consent = value;
  }

  get isSubmitting() {
    return this.requestState === RequestState.REQUESTED;
  }

  get isSuccess() {
    return this.requestState === RequestState.RECEIVED && !!this.successMessage;
  }

  get canSubmit() {
    return (
      !!this.email.trim() &&
      this.consent === true &&
      !this.isSubmitting
    );
  }

  async submit() {
    runInAction(() => {
      this.errorMessage = "";
      this.successMessage = "";
    });

    if (!this.email.trim()) {
      runInAction(() => {
        this.errorMessage = "Email is required.";
      });
      return;
    }

    if (!this.consent) {
      runInAction(() => {
        this.errorMessage = "You must agree to receive updates to join the waitlist.";
      });
      return;
    }

    runInAction(() => {
      this.requestState = RequestState.REQUESTED;
    });

    try {
      const response = await apiService.joinWaitlist({
        email: this.email.trim().toLowerCase(),
        full_name: this.fullName.trim() || undefined,
        consent: true,
      });

      runInAction(() => {
        this.successMessage = get(
          response,
          "data.message",
          "You're on the list! We'll reach out when we launch."
        );
        this.requestState = RequestState.RECEIVED;
      });
    } catch (error) {
      const status = get(error, "response.status");
      const serverMessage = get(error, "response.data.error", "");

      runInAction(() => {
        if (status === 429) {
          this.errorMessage =
            "Too many requests. Please wait a while before trying again.";
        } else {
          this.errorMessage = serverMessage || defaultErrorMessage;
        }
        this.requestState = RequestState.RECEIVED;
      });
    }
  }

  reset() {
    this.email = "";
    this.fullName = "";
    this.consent = false;
    this.requestState = RequestState.IDLE;
    this.errorMessage = "";
    this.successMessage = "";
  }
}

export default WaitlistController;
